import { ChakraProvider, ColorModeScript } from '@chakra-ui/react'
import { AppProvider } from '@hb/react'
import {
  AppErrorBoundary,
  chakraTheme,
  MainWindowProvider,
  polyfills,
  PopUpMessageProvider,
  ToastContainer,
  WebFetchDataProvider,
  WebFirebaseProvider,
} from '@hb/react-web'
import { CookiesProvider } from 'react-cookie'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import { APP_NAME } from './constants'

polyfills()

const container = document.getElementById('root')
const root = container ? createRoot(container) : null
if (root)
  root.render(
    <>
      <ColorModeScript initialColorMode={chakraTheme.config.initialColorMode} />
      <MainWindowProvider>
        <ChakraProvider
          theme={chakraTheme}
          portalZIndex={3}
          toastOptions={{ defaultOptions: { position: 'top' } }}>
          <Router>
            <AppErrorBoundary appName={APP_NAME}>
              <CookiesProvider>
                <PopUpMessageProvider>
                  <WebFirebaseProvider>
                    <WebFetchDataProvider>
                      <AppProvider appName={APP_NAME}>
                        <App />
                      </AppProvider>
                    </WebFetchDataProvider>
                  </WebFirebaseProvider>
                </PopUpMessageProvider>
              </CookiesProvider>
            </AppErrorBoundary>
          </Router>
          {/* </StylesProvider> */}
        </ChakraProvider>
        <ToastContainer />
      </MainWindowProvider>
    </>,
  )
